import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:3000/api`;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth
// Auth
export const login = (email, password, tenantSlug) => api.post('/auth/login', { email, password, tenant_slug: tenantSlug });
export const getTenantBySlug = (slug) => api.get(`/auth/tenant/${slug}`);

// Locations
export const getLocations = (tenantId) => api.get(`/locations/${tenantId}`);
export const getLocation = (id) => api.get(`/locations/single/${id}`);
export const createLocation = (data) => api.post('/locations', data);
export const updateLocation = (id, data) => api.put(`/locations/${id}`, data);
export const deleteLocation = (id) => api.delete(`/locations/${id}`);

// Employees
export const getEmployees = (tenantId) => api.get(`/employees/${tenantId}`);
export const getEmployee = (id) => api.get(`/employees/single/${id}`);
export const createEmployee = (data) => api.post('/employees', data);
export const updateEmployee = (id, data) => api.put(`/employees/${id}`, data);
export const deleteEmployee = (id) => api.delete(`/employees/${id}`);
export const addEmployeeLocation = (id, data) => api.post(`/employees/${id}/locations`, data);
export const removeEmployeeLocation = (id, locationId) => api.delete(`/employees/${id}/locations/${locationId}`);
export const verifyEmployeePin = (employeeId, pinCode) => api.post('/employees/verify-pin', { employee_id: employeeId, pin_code: pinCode });

// Shifts
export const getShiftsByLocation = (locationId, startDate, endDate) => 
  api.get(`/shifts/location/${locationId}`, { params: { start_date: startDate, end_date: endDate } });
export const getShift = (id) => api.get(`/shifts/${id}`);
export const getWeekShifts = (tenantId, startDate) => 
  api.get(`/shifts/week/${tenantId}`, { params: { start_date: startDate } });
export const createShift = (data) => api.post('/shifts', data);
export const updateShift = (id, data) => api.put(`/shifts/${id}`, data);
export const autoAssignShift = (id) => api.post(`/shifts/${id}/auto-assign`);

// Assignments
export const getAssignmentsByShift = (shiftId) => api.get(`/assignments/shift/${shiftId}`);
export const getTodayAssignments = (employeeId) => api.get(`/assignments/employee/${employeeId}/today`);
export const createAssignment = (data) => api.post('/assignments', data);
export const updateAssignment = (id, data) => api.put(`/assignments/${id}`, data);
export const clockIn = (id) => api.put(`/assignments/${id}/clock-in`);
export const clockOut = (id) => api.put(`/assignments/${id}/clock-out`);
export const sendHome = (id) => api.put(`/assignments/${id}/send-home`);
export const reassignEmployee = (id, newShiftId) => api.put(`/assignments/${id}/reassign`, { new_shift_id: newShiftId });
export const deleteAssignment = (id) => api.delete(`/assignments/${id}`);

// Reports
export const getShiftReports = (shiftId) => api.get(`/reports/shift/${shiftId}`);
export const getLatestReport = (shiftId) => api.get(`/reports/shift/${shiftId}/latest`);
export const getLiveDashboard = (tenantId) => api.get(`/reports/live/${tenantId}`);
export const getKPIData = (tenantId, startDate, endDate) => 
  api.get(`/reports/kpi/${tenantId}`, { params: { start_date: startDate, end_date: endDate } });
export const submitReport = (data) => api.post('/reports', data);
export const updateReport = (id, data) => api.put(`/reports/${id}`, data);

// Events
export const getEvents = (tenantId, status) => 
  api.get(`/events/${tenantId}`, { params: status ? { status } : {} });
export const getEvent = (id) => api.get(`/events/single/${id}`);
export const createEvent = (data) => api.post('/events', data);
export const updateEvent = (id, data) => api.put(`/events/${id}`, data);
export const deleteEvent = (id) => api.delete(`/events/${id}`);

// Availability
export const getWeekAvailability = (tenantId, startDate) => 
  api.get(`/availability/week/${tenantId}`, { params: { start_date: startDate } });
export const getEmployeeAvailability = (employeeId, startDate, endDate) => 
  api.get(`/availability/employee/${employeeId}`, { params: { start_date: startDate, end_date: endDate } });
export const submitAvailabilityException = (data) => api.post('/availability', data);
export const deleteAvailabilityException = (id) => api.delete(`/availability/${id}`);

// Templates
export const getTemplates = (tenantId) => api.get(`/templates/${tenantId}`);
export const getLocationTemplates = (locationId) => api.get(`/templates/location/${locationId}`);
export const addTemplate = (data) => api.post('/templates', data);
export const updateTemplate = (id, data) => api.put(`/templates/${id}`, data);
export const deleteTemplate = (id) => api.delete(`/templates/${id}`);
export const deleteTemplateByDetails = (locationId, employeeId, day) => 
  api.delete(`/templates/location/${locationId}/employee/${employeeId}/day/${day}`);
export const updateDayTemplates = (locationId, day, data) => 
  api.put(`/templates/location/${locationId}/day/${day}`, data);

export default api;